<template>
  <div class="page">
    <van-cell-group v-if="data.length">
      <van-cell v-for="item in data" is-link :arrow-direction="item.open ? 'up' : 'down'" :key="item.memberId"
        @click="click(item.memberId, item.open)">
        <template #title>
          <div class="info">
            <img :src="item.headImg" />
            <span>{{ item.phone }}</span>
          </div>
          <span class="count" v-if="item.count !== null">{{ item.count }}</span>
        </template>
        <template #label v-if="item.open">
          <van-cell-group>
            <van-cell v-for="item in item.children" :key="item.memberId" @click.stop="">
              <template #title>
                <div class="info">
                  <img :src="item.headImg" />
                  <span>{{ item.phone }}</span>
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </template>
      </van-cell>
    </van-cell-group>
    <van-empty v-else description="暂无数据" />
  </div>
</template>
<script>
import { Cell, CellGroup, Empty } from 'vant'
import { post } from '@/utils/request'

export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Empty.name]: Empty,
  },
  data() {
    return {
      token: '',
      data: [],
      activeNames: []
    }
  },
  created() {
    this.$bridge.callHandler('getUserInfo', {}, (res) => {
      const d = JSON.parse(res)
      this.token = d.data.accessToken
      post({
        url: '/healthy/auth/healthyRelation/getChild',
        options: { token: this.token }
      })
        .then(res => {
          if (res.code === 0) {
            this.data = res.data.records.map(item => ({ ...item, count: null, children: [], open: false }))
          }
        })
    })
  },
  methods: {
    click(memberId, open) {
      if (open) {
        this.data = this.data.map(item => {
          if (item.memberId == memberId) {
            return {
              ...item,
              open: false,
            }
          }
          return item
        })
        return
      }
      post({
        url: '/healthy/auth/healthyRelation/getChild',
        data: {
          parentId: memberId
        },
        options: { token: this.token }
      })
        .then(res => {
          if (res.code === 0) {
            this.data = this.data.map(item => {
              if (item.memberId == memberId) {
                return {
                  ...item,
                  open: true,
                  children: res.data.records,
                  count: res.data.records?res.data.records.length:0
                }
              }
              return item
            })
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  background: #fff;
}

.count {
  position: absolute;
  right: 50px;
  top: 10px;
}

.info {
  display: flex;
  align-items: center;

  img {
    width: 30px;
    height: 30px;
    overflow: hidden;
    border-radius: 50%;
    margin-right: 10px;
  }
}
</style>
<style>
.van-cell__label .van-hairline--top-bottom:nth-last-of-type(1):after {
  border-bottom: none;
}
</style>